module.exports = __webpack_public_path__ + "static/media/icon-curvabrusca-cinza.8411afdf.svg";